import { WorldGlyph, HabitatGlyph, WardrobeGlyph, JournalGlyph, BagGlyph, MeGlyph } from './glyphs';

/**
 * `paged` — does tapping this tab slide to a sibling page (SCREENS.md "Tab paging")?
 *
 * All five page as of 2026-08-20. Wardrobe used to be the exception — it was a doorway out of the
 * shell to a full-screen modal, so paging it would have animated a page that did not exist. It is
 * an ordinary tab now (docs/RULINGS.md "Wardrobe as a shell tab"), so the exception is gone — the
 * Journal, which takes its dock slot while `wardrobe` is off (#14.1, CLAUDE.md "Hide the empty"),
 * pages too. The flag stays because the NEXT tab that is really a doorway should set it to false
 * rather than rediscover why.
 */
const WORLD = { to: '/world', label: 'World', Glyph: WorldGlyph, paged: true } as const;
const HABITAT = { to: '/habitat', label: 'Habitat', Glyph: HabitatGlyph, paged: true } as const;
const WARDROBE = { to: '/wardrobe', label: 'Wardrobe', Glyph: WardrobeGlyph, paged: true } as const;
// #14.1: while the wardrobe is parked its slot goes to the Journal, one tap from the daily loop.
const JOURNAL = { to: '/journal', label: 'Journal', Glyph: JournalGlyph, paged: true } as const;
const BAG = { to: '/bag', label: 'Bag', Glyph: BagGlyph, paged: true } as const;
const ME = { to: '/me', label: 'Me', Glyph: MeGlyph, paged: true } as const;

/** The five tabs, third slot decided by the `wardrobe` flag (`useFlag('wardrobe')`, resolves
 *  `false` while loading or absent — the same closed-world default the dock renders with). */
export function navItemsFor(wardrobeOn: boolean) {
  return [WORLD, HABITAT, wardrobeOn ? WARDROBE : JOURNAL, BAG, ME] as const;
}

/**
 * Which tab owns a pathname, or -1 for a route with no tab of its own.
 *
 * Prefix-matched, so a tab stays lit for its own sub-routes (`/me/badges` is still Me) — the same
 * rule NavLink's own `aria-current` uses, kept in one place so the sliding plate and the lit tab
 * can never disagree about which one is active.
 */
export function navIndexFor(pathname: string, wardrobeOn: boolean): number {
  return navItemsFor(wardrobeOn).findIndex(({ to }) => pathname === to || pathname.startsWith(`${to}/`));
}
